module.exports = __webpack_public_path__ + "img/plan_card.9d00c068.png";